export enum RequirePermission {
    AddSchemaForm = 'AddSchemaForm',
    UpdateSchemaForm = 'UpdateSchemaForm',
    GetInspectionType = 'GetInspectionType',
    AddCategoryType = 'AddCategoryType',
    UpdateCategoryType = 'UpdateCategoryType',
    AddGroup = 'AddGroup',
    UpdateGroup = 'UpdateGroup',
    GetRole = 'GetRole',
    AddInspectionTypeGroup = 'AddInspectionTypeGroup',
    UpdateInspectionTypeGroup = 'UpdateInspectionTypeGroup',
    AddInspectionType = 'AddInspectionType',
    UpdateInspectionType = 'UpdateInspectionType',
    AddRole = 'AddRole',
    UpdateRole = 'UpdateRole',
    AddTenant = 'AddTenant',
    UpdateTenantStyle = 'UpdateTenantStyle',
    AddTenantStyle = 'AddTenantStyle',
    NotExistPermission = 'NotExistPermission',
    GetTenant = 'GetTenant',
    GetTenantStyle = 'GetTenantSyle',
    GetInspectionTypeGroup = 'GetInspectionTypeGroup',
    GetGroup = 'GetGroup',
    GetCategoryType = 'GetCategoryType',
    GetLocation = 'GetLocation',
    GetOperationalSupport = 'GetOperationalSupport',
    UpdateTenant = 'UpdateTenant',
    GetPermission = 'GetPermission',
    GetPicklistEditor = 'GetPicklistEditor'
}
